<template>
    <div id="app">
		<Header></Header>
		<router-view/>
		<Footer></Footer>
    </div>
</template>
<script> 
import Header from './components/header.vue'
import Footer from './components/footer.vue'
export default{
	components: { Header,Footer },
	name:'App',
	mounted(){

	}
 }
</script>

<style scoped>
  
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
